export default {"src":"/_next/static/media/coinGecko.a50d6aa4.svg","height":276,"width":276,"blurWidth":0,"blurHeight":0};